export default "__VITE_ASSET__CPJwsWeb__"